import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { ChevronLeft, ChevronRight } from 'react-feather';
import Breadcrumb from '../../components/base/Breadcrumb';
import CardComponent from '../../components/base/CardComponent';
import HorizontalRule from '../../components/base/HorizontalRule';
import PagesHeader from '../../components/base/PagesHeader';
import LineChart from '../../components/charts/LineChart';
import TableComponent from '../../components/table/TableComponent';
import { EmployeePensionPaidData, EmployeePensionPaidHeader } from '../../dummy/data';
import { IBreadCrumb } from '../../types/base/BreadCrumb';
import { EmployeePensionPaidDataType } from '../../types/base/TableTypes';

const breadcrumb: IBreadCrumb[] = [
  {
    name: 'Overview',
    href: '/dashboard',
  },
  {
    name: 'Pension Paid',
  },
];

const tabledata: EmployeePensionPaidDataType = {
  type: 'EMPLOYEE_PENSION_PAID',
  data: EmployeePensionPaidData,
};

function PensionPaidPage() {
  return (
    <div>
      <Breadcrumb navItem={breadcrumb} />
      <PagesHeader pageTitle="Pension Paid" />
      <CardComponent>
        <Form className="mb-3">
          <div className="d-flex align-items-end flex-wrap gap-5">
            <Button type="button" variant="primary">
              <ChevronLeft className="icon-gap-right" /> Invoices
            </Button>

            <Form.Group className="w-25">
              <Form.Label>Period</Form.Label>
              <Form.Select name="Period" placeholder="Enter Period">
                <option>Rolling 6 months</option>
                <option>...</option>
              </Form.Select>
            </Form.Group>

            <Button type="button" variant="primary">
              Invoices <ChevronRight className="icon-gap-left" />
            </Button>
          </div>
        </Form>
        <HorizontalRule />
        <div className="mb-3">
          <LineChart />
        </div>
        <HorizontalRule />
        <PagesHeader pageTitle="Pension Companies" />
        <TableComponent header={EmployeePensionPaidHeader} tableItem={tabledata} />
      </CardComponent>
    </div>
  );
}

export default PensionPaidPage;
